.root {
  &.primary {
    background: transparent;

    &[data-variant='transparent'] {
      color: var(--mantine-color-otherBlack-0);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-7);
        }
      }

      &:active {
        color: var(--mantine-color-primary-7);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-primary-9);
      }
    }

    &[data-variant='subtle'] {
      color: var(--mantine-color-primary-9);
      background-color: transparent;

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-7);
          background-color: var(--mantine-color-primary-0);
        }
      }

      &:active {
        color: var(--mantine-color-primary-7);
        background-color: var(--mantine-color-primary-0);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        background-color: var(--mantine-color-primary-0);
      }
    }

    &[data-variant='filled'] {
      color: var(--mantine-color-primary-0);
      background-color: var(--mantine-color-primary-9);

      @media (hover: hover) {
        &:hover {
          background-color: var(--mantine-color-primary-9);
        }
      }

      &:active {
        background-color: var(--mantine-color-primary-9);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        background-color: var(--mantine-color-primary-0);
      }
    }

    &[data-variant='light'] {
      color: var(--mantine-color-primary-9);
      background-color: var(--mantine-color-primary-0);

      @media (hover: hover) {
        &:hover {
          background-color: var(--mantine-color-primary-2);
        }
      }

      &:active {
        color: var(--mantine-color-primary-7);
        background-color: var(--mantine-color-primary-2);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-tertiary-2);
        background-color: var(--mantine-color-tertiary-0);
      }
    }

    &[data-variant='outline'] {
      background-color: transparent;
      color: var(--mantine-color-primary-5);
      border-color: var(--mantine-color-primary-5);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-7);
          border-color: var(--mantine-color-primary-9);
        }
      }

      &:active {
        color: var(--mantine-color-primary-7);
        border-color: var(--mantine-color-primary-9);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        border-color: var(--mantine-color-primary-0);
      }
    }

    &[data-variant='default'] {
      background-color: transparent;
      color: var(--mantine-color-primary-0);
      border-color: var(--mantine-color-primary-7);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-0);
          background-color: var(--mantine-color-primary-2);
          border-color: var(--mantine-color-primary-0);
        }
      }

      &:active {
        color: var(--mantine-color-primary-0);
        background-color: var(--mantine-color-primary-2);
        border-color: var(--mantine-color-primary-0);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        background-color: var(--mantine-color-primary-9);
        border-color: var(--mantine-color-textDisabled);
      }
    }
  }

  &.secondary {
    &[data-variant='transparent'] {
      color: var(--mantine-color-secondary-7);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-secondary-9);
        }
      }

      &:active {
        color: var(--mantine-color-secondary-9);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
      }
    }

    &[data-variant='subtle'] {
      color: var(--mantine-color-secondary-7);
      background-color: transparent;

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-secondary-9);
          background-color: transparent;
        }
      }

      &:active {
        color: var(--mantine-color-secondary-9);
        background-color: transparent;
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        background-color: var(--mantine-color-primary-0);
      }
    }

    &[data-variant='filled'] {
      color: var(--mantine-color-otherWhite-0);
      background-color: var(--mantine-color-secondary-7);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-otherWhite-0);
          background-color: var(--mantine-color-secondary-9);
        }
      }

      &:active {
        color: var(--mantine-color-otherWhite-0);
        background-color: var(--mantine-color-secondary-9);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-otherWhite-0);
        background-color: var(--mantine-color-primary-0);
      }
    }

    &[data-variant='white'] {
      color: var(--mantine-color-secondary-9);
      background-color: var(--mantine-color-primary-0);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-secondary-9);
          background-color: var(--mantine-color-primary-0);
        }
      }

      &:active {
        color: var(--mantine-color-secondary-9);
        background-color: var(--mantine-color-primary-0);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        background-color: var(--mantine-color-textDisabled);
      }
    }

    &[data-variant='outline'] {
      background-color: transparent;
      color: var(--mantine-color-secondary-7);
      border-color: var(--mantine-color-secondary-7);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-secondary-9);
          border-color: var(--mantine-color-secondary-9);
        }
      }

      &:active {
        color: var(--mantine-color-secondary-9);
        border-color: var(--mantine-color-secondary-9);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        border-color: var(--mantine-color-textDisabled);
      }
    }

    &[data-variant='default'] {
      background-color: transparent;
      color: var(--mantine-color-secondary-7);
      border-color: var(--mantine-color-secondary-7);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-otherWhite-0);
          border-color: var(--mantine-color-secondary-9);
          background-color: var(--mantine-color-secondary-9);
        }
      }

      &:active {
        color: var(--mantine-color-otherWhite-0);
        border-color: var(--mantine-color-secondary-9);
        background-color: var(--mantine-color-secondary-7);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
        border-color: var(--mantine-color-textDisabled);
      }
    }
  }

  &.gray {
    &[data-variant='transparent'] {
      color: var(--mantine-color-primary-7);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-9);
        }
      }

      &:active {
        color: var(--mantine-color-primary-9);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-primary-9);
      }
    }

    &[data-variant='subtle'] {
      color: var(--mantine-color-primary-7);
      background-color: transparent;

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-7);
          background-color: var(--mantine-color-primary-0);
        }
      }

      &:active {
        color: var(--mantine-color-otherWhite-5);
        background-color: var(--mantine-color-primary-2);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
      }
    }

    &[data-variant='filled'] {
      color: var(--mantine-color-otherWhite-0);
      background-color: var(--mantine-color-primary-9);

      @media (hover: hover) {
        &:hover {
          background-color: var(--mantine-color-primary-7);
        }
      }

      &:active {
        background-color: var(--mantine-color-primary-7);
      }

      &[data-disabled='true'] {
        background-color: var(--mantine-color-primary-9);
      }
    }

    &[data-variant='light'] {
      color: var(--mantine-color-primary-7);
      background-color: var(--mantine-color-primary-0);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-otherWhite-0);
          background-color: var(--mantine-color-primary-9);
        }
      }

      &:active {
        color: var(--mantine-color-otherWhite-0);
        background-color: var(--mantine-color-primary-9);
      }

      &[data-disabled='true'] {
        &:active {
          background-color: var(--mantine-color-otherWhite-0);
          color: var(--mantine-color-primary-9);
        }
      }
    }

    &[data-variant='outline'] {
      background-color: transparent;
      color: var(--mantine-color-primary-9);
      border-color: var(--mantine-color-primary-9);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-0);
          border-color: var(--mantine-color-primary-7);
          background-color: var(--mantine-color-primary-7);
        }
      }

      &:active {
        color: var(--mantine-color-primary-0);
        border-color: var(--mantine-color-primary-7);
        background-color: var(--mantine-color-primary-7);
      }

      &[data-disabled='true'] {
        border-color: var(--mantine-color-primary-9);
      }
    }

    &[data-variant='default'] {
      background-color: transparent;
      color: var(--mantine-color-primary-0);
      border-color: var(--mantine-color-primary-0);

      @media (hover: hover) {
        &:hover {
          color: var(--mantine-color-primary-0);
          border-color: var(--mantine-color-primary-0);
        }
      }

      &:active {
        color: var(--mantine-color-primary-0);
        border-color: var(--mantine-color-primary-0);
      }

      &[data-disabled='true'] {
        color: var(--mantine-color-textDisabled);
      }
    }
  }

  &[data-size='xs'] {
    svg {
      @extend %icon-xs;
    }
  }

  &[data-size='sm'] {
    svg {
      @extend %icon-sm;
    }
  }

  &[data-size='md'] {
    svg {
      @extend %icon-md;
    }
  }

  &[data-size='lg'] {
    svg {
      @extend %icon-lg;
    }
  }

  &[data-size='xl'] {
    svg {
      @extend %icon-xl;
    }
  }
}
